// extracted by mini-css-extract-plugin
export default {"sendButton":"SendButton_sendButton__MgKX0","sendButtonActive":"SendButton_sendButtonActive__YLuRt"};